import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            'click': 'onClick'
        }
    }

    init() {
    }

    onClick(e) {
        this.show()
    }

    show() {
        this.el.setAttribute('aria-expanded', 'true')

        this.call('show', null, 'NewsletterModal')
    }

    close(){
        this.el.setAttribute('aria-expanded', 'false')
    }
}
